import React from 'react';

function InnogamesLogoIcons() {
	return(
		<svg
			viewBox="0 0 546.31 69.06">
			<title>Innogames Logo</title>
			<path
				fill="currentColor" 
				className="ac08d4cc-4e6a-4266-9207-a0cb021fde6a" 
				d="M37.18,37.76c-3.14-2.36-11-7.87-11-18.88S34,0,45.05,0,63.93,7.87,63.93,18.88s-7.87,16.52-11,18.88c3.93-4.72,8.65-9.44,8.65-18.88S54.49,3.15,45.05,3.15,28.53,9.44,28.53,18.88,33.25,33,37.18,37.76Z"/>
			<path
				fill="currentColor" 
				className="ac08d4cc-4e6a-4266-9207-a0cb021fde6a" 
				d="M36.52,40.91c2.24,1.57,10.89,1.57,17.18,0C49.77,44.84,35.61,45.63,36.52,40.91Z"/>
			<path
				fill="currentColor" 
				className="ac08d4cc-4e6a-4266-9207-a0cb021fde6a" 
				d="M37.18,44.84c2.24,1.57,9.44,1.57,15.74,0C49,48.77,36.28,49.56,37.18,44.84Z"/>
			<path
				fill="currentColor" 
				className="ac08d4cc-4e6a-4266-9207-a0cb021fde6a" 
				d="M38,48.77c2.24,1.58,7.87,1.58,14.16,0C48.2,52.71,37.06,53.49,38,48.77Z"/>
			<path
				fill="currentColor" 
				className="ac08d4cc-4e6a-4266-9207-a0cb021fde6a" 
				d="M44.06,37.59C48,36.7,48,32.23,45.61,27.45s-5-7.1-4.66-9.77,9.92-2.36,9.1.52c4.41-4-10.32-5.1-10.73-.66-.28,3.1,2.85,5.92,5.18,10.28S47.43,35.93,44.06,37.59Z"/>
			<path
				fill="currentColor" 
				className="ac08d4cc-4e6a-4266-9207-a0cb021fde6a" 
				d="M53.77,64.54C87.49,73.8,99,62.36,82.93,49.75a22.33,22.33,0,0,1-2,1.76C90.32,60.78,83,65.86,62.31,61.74,59.41,62.81,56.85,63.67,53.77,64.54Z"/>
			<path
				fill="currentColor" 
				className="ac08d4cc-4e6a-4266-9207-a0cb021fde6a" 
				d="M78.3,46.55A89,89,0,0,0,62,39a102,102,0,0,1,14.61,8.86A11.29,11.29,0,0,0,78.3,46.55Z"/>
			<path
				fill="currentColor" 
				className="ac08d4cc-4e6a-4266-9207-a0cb021fde6a" 
				d="M22.3,27.56C-3.81,21.66,3,46.63,42.4,60.9c1.94-.42,5.13-1.23,8.16-2.1-2-.57-4-1.2-6.06-1.89C14.57,47-3.3,25.34,22.3,27.56Z"/>
			<path
				fill="currentColor" 
				className="ac08d4cc-4e6a-4266-9207-a0cb021fde6a" 
				d="M14.63,46.63A21.33,21.33,0,0,1,13,45.23C-13,57.21.66,77.6,47.69,65.19c44-11.6,50.72-32.71,15.79-29.3,29.75.29,22.08,15.59-16.9,25.09C11.34,69.56-6.95,59,14.63,46.63Z"/>
			<path
				fill="currentColor" 
				className="ac08d4cc-4e6a-4266-9207-a0cb021fde6a" 
				d="M20.53,43.67Q24.64,41.83,30,40a89.46,89.46,0,0,0-10.64,2.75A14.75,14.75,0,0,0,20.53,43.67Z"/>
			<path
				fill="currentColor" 
				className="ac08d4cc-4e6a-4266-9207-a0cb021fde6a" 
				d="M98,68V1.33h12.5V68Z"/>
			<path
				fill="currentColor" 
				className="ac08d4cc-4e6a-4266-9207-a0cb021fde6a" 
				d="M149.48,68V29.75c0-.62-.34-.93-1-.93H131.66c-.65,0-1,.31-1,.93V68h-12.5V28.82q0-2.88,3.37-4.89a15,15,0,0,1,7-1.7h23a15.2,15.2,0,0,1,3.71.46A12.94,12.94,0,0,1,158.63,24a8,8,0,0,1,2.42,2.07,4.43,4.43,0,0,1,.93,2.74V68Z"/>
			<path
				fill="currentColor" 
				className="ac08d4cc-4e6a-4266-9207-a0cb021fde6a" 
				d="M200.9,68V29.75c0-.62-.35-.93-1-.93h-16.8c-.65,0-1,.31-1,.93V68H169.6V28.82q0-2.88,3.37-4.89a15,15,0,0,1,7-1.7h23a15.26,15.26,0,0,1,3.71.46A13.08,13.08,0,0,1,210.05,24a8.07,8.07,0,0,1,2.42,2.07,4.43,4.43,0,0,1,.93,2.74V68Z"/>
			<path
				fill="currentColor" 
				className="ac08d4cc-4e6a-4266-9207-a0cb021fde6a" 
				d="M263.79,64.1a8.2,8.2,0,0,1-2.42,2.12A12.36,12.36,0,0,1,258,67.56a15.15,15.15,0,0,1-3.71.47h-23a13.87,13.87,0,0,1-7-1.81q-3.36-1.91-3.36-4.88V28.82q0-2.88,3.36-4.89a15.09,15.09,0,0,1,7-1.7h23a15.14,15.14,0,0,1,3.71.46A13,13,0,0,1,261.37,24a8.07,8.07,0,0,1,2.42,2.07,4.48,4.48,0,0,1,.92,2.74V61.34A4.56,4.56,0,0,1,263.79,64.1ZM252.21,29.75q0-.93-1-.93h-16.8c-.65,0-1,.31-1,.93V60.51c0,.55.32.83,1,.83h16.8c.68,0,1-.28,1-.83Z"/>
			<path
				fill="currentColor" 
				className="ac08d4cc-4e6a-4266-9207-a0cb021fde6a" 
				d="M282.54,68a13.87,13.87,0,0,1-7-1.81q-3.36-1.91-3.36-4.88V8q0-2.88,3.36-4.89a13.87,13.87,0,0,1,7-1.8h41.69V8H285.61c-.65,0-1,.27-1,.83V60.51c0,.55.32.83,1,.83h26.12V32.24q0-2.49-3.12-2.49h-10.5V23h26.12V68Z"/>
			<path
				fill="currentColor" 
				className="ac08d4cc-4e6a-4266-9207-a0cb021fde6a" 
				d="M341,68a13.83,13.83,0,0,1-7-1.81q-3.37-1.91-3.37-4.88v-20q0-2.88,3.37-4.89a15,15,0,0,1,7-1.7h20.9v-5c0-.62-.34-.93-1-.93H332.73V22.23H364a15.2,15.2,0,0,1,3.71.46A13.15,13.15,0,0,1,371.09,24a8,8,0,0,1,2.41,2.07,4.43,4.43,0,0,1,.93,2.74V68Zm20.9-26.71H344.11c-.65,0-1,.31-1,.93V60.51c0,.55.33.83,1,.83h17.82Z"/>
			<path
				fill="currentColor" 
				className="ac08d4cc-4e6a-4266-9207-a0cb021fde6a" 
				d="M432,68V29.75c0-.62-.34-.93-1-.93H420.48c-.66,0-1,.31-1,.93V68H407V29.75c0-.62-.34-.93-1-.93H395.48c-.66,0-1,.31-1,.93V68H382V28.82q0-2.88,3.37-4.89a15,15,0,0,1,7-1.7h41.7a13.88,13.88,0,0,1,3.81.41A12,12,0,0,1,441.2,24a8.19,8.19,0,0,1,2.35,2.13,4.79,4.79,0,0,1,.95,2.71V68Z"/>
			<path
				fill="currentColor" 
				className="ac08d4cc-4e6a-4266-9207-a0cb021fde6a" 
				d="M494.89,44.47a8.2,8.2,0,0,1-2.42,2.12A13.15,13.15,0,0,1,489.13,48a14.83,14.83,0,0,1-3.71.49h-20.9V60.51c0,.55.32.83,1,.83h28.13V68h-31.2a13.81,13.81,0,0,1-7-1.81Q452,64.32,452,61.34V28.82q0-2.88,3.37-4.89a15,15,0,0,1,7-1.7h23a15.26,15.26,0,0,1,3.71.46A13.08,13.08,0,0,1,492.47,24a8.07,8.07,0,0,1,2.42,2.07,4.43,4.43,0,0,1,.93,2.74V41.71A4.5,4.5,0,0,1,494.89,44.47ZM483.32,29.75c0-.62-.34-.93-1-.93h-16.8c-.65,0-1,.31-1,.93v12h17.77c.69,0,1-.26,1-.78Z"/>
			<path
				fill="currentColor" 
				className="ac08d4cc-4e6a-4266-9207-a0cb021fde6a" 
				d="M545.38,64.1A8.2,8.2,0,0,1,543,66.22a12.42,12.42,0,0,1-3.34,1.34,15.29,15.29,0,0,1-3.72.47H502.51V61.34h30.27c.68,0,1-.28,1-.83V49.23c0-.52-.35-.78-1-.78H512.91a14.94,14.94,0,0,1-7-1.71q-3.37-1.91-3.37-5V28.82q0-2.88,3.37-4.89a15,15,0,0,1,7-1.7h33.4v6.59H516c-.65,0-1,.31-1,.93V40.93c0,.52.32.78,1,.78H535.9a14.4,14.4,0,0,1,3.72.49A13.14,13.14,0,0,1,543,43.56a8.23,8.23,0,0,1,2.42,2.13,4.5,4.5,0,0,1,.93,2.76V61.34A4.5,4.5,0,0,1,545.38,64.1Z"/>
		</svg>
		
	);
}

export default InnogamesLogoIcons;
